export default __webpack_public_path__ + "static/media/about.8ddc2ec3.jpg";